import _ from 'lodash-es';
import Utils from '~/scripts/services/utils';

/* globals Knitiv */

export default class MailFormHeaderController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor(
		$element,
		$rootScope,
		$timeout,
	) {
		this.$element = $element;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;

		/** @type {any[]} */
		this.data = [];

		/** @type {boolean} */
		this.disabled = false;

		/** @type {any} */
		this.loading = false;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {{ hideFrom?: boolean }} */
		this.options = {};

		/** @type {any} */
		this.recipients = {};

		/** @type {boolean} */
		this.required = false;

		/** @type {any} */
		this.types = {};
	}

	$doCheck() {
		if ('hideFrom' in this.options) {
			this.types.from.display = !this.options.hideFrom;
		}
	}

	$onInit() {
		this.options = _.merge({
			hideFrom: false,
		}, this.options || {});

		this.types.from = { display: !this.options.hideFrom, readOnly: true };
		this.types.to = { display: true, readOnly: false };
		this.types.cc = { display: false, readOnly: false };
		this.types.bcc = { display: false, readOnly: false };

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.email = (modelValue, viewValue) => {
				let pass = true;
				if (this.required) {
					for (const recipient of viewValue) {
						const email = recipient.email?.kid ? recipient.email.name : recipient.email;
						if (recipient.person?.isa !== 'K_NODE;MAILINGLIST' && email && !Utils.checkEmail(email)) {
							pass = false;
						}
					}
					if (pass) {
						pass = false;
						for (const recipient of viewValue) {
							const email = recipient.email?.kid ? recipient.email.name : recipient.email;
							if (
								recipient.person?.isa !== 'K_NODE;MAILINGLIST'
								|| (email && Utils.checkEmail(email) && recipient.type === 'to')
							) {
								pass = true;
							}
						}
					}
				}

				return pass;
			};
		}
	}

	/**
	 * @param {any} recipient
	 */
	addRecipient(recipient) {
		if (!Array.isArray(this.data)) {
			this.data = [];
		}
		this.data.push(recipient);
		this.ngModelCtrl?.$validate();
	}

	/**
	 * @param {any} recipient
	 */
	delRecipient(recipient) {
		_.remove(this.data, v => recipient.$$hashKey === v.$$hashKey);
		this.ngModelCtrl?.$validate();
	}

	/**
	 * @param {string} type
	 */
	displayType(type) {
		this.types[type].display = true;
		this.$timeout(() => this.setFocus(type));
	}

	/**
	 * @param {string} type
	 */
	setFocus(type) {
		this.$element.find(`.form-control[name=recipient_${type}]`).val('').trigger('focus');
	}
}
